import axios from 'axios'
import store from '../store.js';
import router from '../router';

function HandleError(r) {
    if(r.response.status === 401) {
        store.commit("ClearCredentials")
        router.push({name: 'login'});
    }
    else{
        console.error(r);
    }
}

function get(url) {
    //url = 'https://localhost:44350' + url.replace('/xaf', '');
    return axios.get(url, { withCredentials: true }).catch(HandleError);
}

function post(url, data) {
    return axios.post(url, data, { withCredentials: true }).catch(HandleError);
}

function put(url, data) {
    return axios.put(url, data, { withCredentials: true }).catch(HandleError);
}

export default {
    get,
    post,
    put
}


// WEBPACK FOOTER //
// ./src/services/Api.js